<section class="table-wrapper">
    <div class="header">
        <h4>Facturi</h4>

        <div class="header-tools">
            <app-search-bar></app-search-bar>
            <app-table-filters title="Filtrează" [routeParams]="['status']">
                <app-select-filter field="status" [options]="filterStatuses" placeholder="Status">
                </app-select-filter>
            </app-table-filters>
        </div>

        <div class="header-overlay" *ngIf="selection.selected.length as selectedNo" fxLayout="row"
             fxLayoutAlign="space-between center">
            <span>{{selectedNo}} items selected</span>
            <button mat-icon-button matTooltip="Clear selection" (click)="clearSelection()">
                <nb-icon icon="close-outline"></nb-icon>
            </button>
        </div>
    </div>

    <div class="download-csv-header" fxLayout="row" fxLayoutAlign="flex-end center" fxLayoutGap="10px" *ngIf="allowDownloadCSV">
        <app-select-input [appendTo]="'body'" [items]="monthOptions" placeholder="Selectați luna"
                          [value]="selectedMonthForDownloadCSV" (valueChange)="selectedMonthChanged($event)"
                          [clearable]="false" [searchable]="false"></app-select-input>
        <button mat-flat-button color="primary" type="button" (click)="exportInvoicesAsCSV()"
                [buttonSpinner]="isLoadingCSV">
            Exporta facturi ca CSV
        </button>
    </div>

    <div class="table-container" [nbSpinner]="isLoading" nbSpinnerStatus="primary">
        <table mat-table matSort aria-label="Users" [dataSource]="data" [matSortActive]="activeSort"
               [matSortDirection]="activeSortDirection">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle($event) : null" #masterToggleCheckbox>
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <mat-checkbox (change)="$event ? toggleCheckbox(row._id) : null"
                                  [checked]="selection.isSelected(row._id)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="operator">
                <th mat-header-cell *matHeaderCellDef >Operator</th>
                <td mat-cell *matCellDef="let row">
                    <a class="link" [routerLink]="authService.userCan('operators:view') ? ['/admin/operators/view/', row.operator._id] : []">
                        {{row.operator.company.name}}
                    </a>
                </td>
            </ng-container>

            <ng-container matColumnDef="serialNumber">
                <th mat-header-cell *matHeaderCellDef >Seria si Numar</th>
                <td mat-cell *matCellDef="let row">
                    {{row.serial}}-{{row.number}}
                </td>
            </ng-container>

<!--            <ng-container matColumnDef="month">-->
<!--                <th mat-header-cell *matHeaderCellDef >Luna</th>-->
<!--                <td mat-cell *matCellDef="let row">{{row.month}}</td>-->
<!--            </ng-container>-->
            <ng-container matColumnDef="createdTs">
                <th mat-header-cell *matHeaderCellDef >Data factura</th>
                <td mat-cell *matCellDef="let row">{{row.createdTs | date: 'short'}}</td>
            </ng-container>
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef >Suma</th>
                <td mat-cell *matCellDef="let row">{{row.amount / 100}} Lei</td>
            </ng-container>
            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef >Status</th>
                <td mat-cell *matCellDef="let row">
                    <app-badge *ngIf="row.status === 'new'" text="Noua" [status]="'danger'"></app-badge>
                    <app-badge *ngIf="row.status === 'paid'" text="Platita" [status]="'success'"></app-badge>
                    <app-badge *ngIf="row.status === 'canceled'" text="Anulata" [status]="'warning'"></app-badge>
                </td>
            </ng-container>

            <ng-container matColumnDef="drivers">
                <th mat-header-cell *matHeaderCellDef >Șoferi</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngFor="let driverData of row.drivers">
                        <a [routerLink]="['/admin/drivers/view', driverData.driver._id]">{{driverData.driver.profile.firstName}} {{driverData.driver.profile.lastName}}</a> - {{driverData.amount / 100}} Lei
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="cell-center">Actions</th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()" class="cell-center">
                    <button mat-icon-button matTooltip="Marchează ca platit" *ngIf="row.status === 'new' && authService.userCan('invoices:markAsPaid')" (click)="markAsPaid(row)"
                            class="tapp-action-button">
                        <mat-icon color="success">done</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="Vezi factura" class="tapp-action-button" (click)="downloadInvoice(row)">
                        <mat-icon color="success">receipt</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"></tr>
        </table>
    </div>

    <mat-paginator [length]="dataLength" [pageIndex]="activePage" [pageSize]="activeLength"
                   [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
    </mat-paginator>
</section>
